<template>

  <div class="Accordion-container">
    <PageHeader
      title="Publication Manager"
      subtitle="Publish tests and manage access for student groups"
      icon="bi-megaphone"
      color="orange"
    >
      <template #actions>
        <!-- Bouton pour ouvrir le créateur de publication -->
        <button
          class="btn-create-publication"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#PubCreator"
          aria-expanded="false"
          aria-controls="PubCreator"
          @click="togglePubCreator"
        >
          <i class="bi bi-plus-circle"></i>
          <span>Create Publication</span>
        </button>
        <!-- Vos autres boutons d'actions ici -->
        <slot name="actions"></slot>
      </template>
    </PageHeader>

    <!-- Statistics Indicators -->
  <div class="statistics-container">
    <div class="stat-card stat-card-blue">
      <div class="stat-icon">
        <i class="bi bi-files"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.totalPublications }}</div>
        <div class="stat-label">Total Publications</div>
      </div>
    </div>

    <div class="stat-card stat-card-green">
      <div class="stat-icon">
        <i class="bi bi-unlock"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.openPublications }}</div>
        <div class="stat-label">Open Publications</div>
      </div>
    </div>

    <div class="stat-card stat-card-purple">
      <div class="stat-icon">
        <i class="bi bi-list-ol"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.linearTests }}</div>
        <div class="stat-label">Linear Tests</div>
      </div>
    </div>

    <div class="stat-card stat-card-orange">
      <div class="stat-icon">
        <i class="bi bi-diagram-3"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.catTests }}</div>
        <div class="stat-label">CAT Tests</div>
      </div>
    </div>

    <div class="stat-card stat-card-teal">
      <div class="stat-icon">
        <i class="bi bi-signpost-split"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.branchTests }}</div>
        <div class="stat-label">Branch Tests</div>
      </div>
    </div>

    <div class="stat-card stat-card-pink">
      <div class="stat-icon">
        <i class="bi bi-mortarboard"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.examModePublications }}</div>
        <div class="stat-label">Exam Mode</div>
      </div>
    </div>
  </div>

    <br>
    <div class="accordion" id="PublicationCreator">

      <div hidden class="accordion-item">
        <h2 class="accordion-header" id="PublicationPresentation">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#PubPres"
            aria-expanded="true" aria-controls="PubPres">
            <h3> Discover the Publication Manager</h3>
          </button>
        </h2>
        <div id="PubPres" class="accordion-collapse collapse hide" aria-labelledby="PublicationPresentation"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">

            <PublicationPresentation />

          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#PubCreator"
            aria-expanded="true" aria-controls="PubCreator">
            <h3>Create a Publication</h3>
          </button>
        </h2>
        <div id="PubCreator" class="accordion-collapse collapse " aria-labelledby="headingOne"
          data-bs-parent="#PublicationCreator">

          <div class="accordion-body">
            <publicationCreator />
          </div>
        </div>
      </div>
      <div class="mainContainer Publist">
        <h3>Publication List</h3>
        <div id="upcoming" class="" aria-labelledby="headingOne">
          <div class="">
            <div class="row mb-4">
              <PublicationTable @publication-selected="fetchPublicationDetails" />

            </div>
            <div class="row">
              <PublicationCard v-if="selectedPublication" :publication="selectedPublication" />
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import PageHeader from '../common/PageHeader.vue';
import publicationCreator from '../publication/PublicationCreator.vue';
import PublicationCard from '../publication/PublicationCard.vue';
import PublicationPresentation from '../publication/PublicationPresentation.vue';
import PublicationTable from '../publication/PublicationTable.vue';
import api from "@/services/axios";
import PublicationAgenda from "../PublicationAgenda.vue";

const selectedPublication = ref(null); // Publication actuellement sélectionnée

// Statistics data
const statistics = ref({
  totalPublications: 0,
  openPublications: 0,
  linearTests: 0,
  catTests: 0,
  branchTests: 0,
  examModePublications: 0
});

// Fetch statistics
const fetchStatistics = async () => {
  try {
    const response = await api.get('/publications/statistics');
    statistics.value = response.data;
  } catch (error) {
    console.error('Error fetching publication statistics:', error);
  }
};

// Load statistics on mount
onMounted(() => {
  fetchStatistics();
});

async function fetchPublicationDetails(publicationId) {

  try {
    const response = await api.get(`/publications/${publicationId}`);
    selectedPublication.value = response.data; // Charger les détails de la publication
  } catch (error) {
    console.error("Erreur lors de la récupération des détails de la publication :", error);
  }
}

// Fonction pour gérer l'ouverture/fermeture du panneau de création
const togglePubCreator = () => {
  const pubCreatorElement = document.getElementById('PubCreator');
  const isCurrentlyOpen = pubCreatorElement?.classList.contains('show');
  
  if (isCurrentlyOpen) {
    pubCreatorElement.classList.remove('show');
  } else {
    pubCreatorElement.classList.add('show');
  }
}

</script>

<style scoped>
.presentation {
  margin-left: 20px;
}

.presentation h1 {
  font-size: 1.6rem;
}

button h3 {
  font-size: 1.3rem;
}

.targetDefinition {
  border: 2px solid gainsboro;
  border-radius: 5px;
  padding: 10px;
  background-color: #f4ebfa;
}

/* Accordion moderne et saillant */
.accordion {
  margin-bottom: 30px;
}

.accordion-item {
  border: 2px solid #E0E0E0;
  border-radius: 12px !important;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(245, 124, 0, 0.15);
  transition: all 0.3s ease;
}

.accordion-item:hover {
  box-shadow: 0 6px 16px rgba(245, 124, 0, 0.25);
  transform: translateY(-2px);
}

.accordion-button {
  background: linear-gradient(135deg, #F57C00 0%, #E65100 100%) !important;
  color: white !important;
  border: none !important;
  padding: 18px 24px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.accordion-button h3 {
  color: white !important;
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}

.accordion-button h3::before {
  content: "📋";
  font-size: 1.4rem;
}

.accordion-button:hover {
  background: linear-gradient(135deg, #E65100 0%, #D84315 100%) !important;
}

.accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #E65100 0%, #BF360C 100%) !important;
  color: white !important;
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1);
}

.accordion-button::after {
  filter: brightness(0) invert(1);
}

.accordion-button:focus {
  box-shadow: 0 0 0 3px rgba(245, 124, 0, 0.25) !important;
  outline: none !important;
}

.accordion-body {
  padding: 24px;
  background-color: #FAFBFC;
  border-top: 2px solid #FFE0B2;
}

.Accordion-container {
  border-left: 1px gainsboro solid;
  border-radius: 5px;
  padding: 20px;
  background-color: #F8F9FA !important;
}

.pubTitle {
  padding: 20px
}

.Publist {
  padding: 20px;
  border-radius: 5px;
  background-color: #F8F9FA !important;
  border-left: 1px gainsboro solid;
  border-right: 1px gainsboro solid;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

/* Bouton Create Publication moderne */
.btn-create-publication {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #F57C00 0%, #E65100 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(245, 124, 0, 0.3);
}

.btn-create-publication i {
  font-size: 1.1rem;
}

.btn-create-publication:hover {
  background: linear-gradient(135deg, #E65100 0%, #BF360C 100%);
  box-shadow: 0 4px 12px rgba(245, 124, 0, 0.4);
  transform: translateY(-2px);
}

.btn-create-publication:active {
  transform: translateY(0);
}

/* Statistics Indicators */
.statistics-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin: 20px 0;
  padding: 0;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.stat-icon {
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  flex-shrink: 0;
}

.stat-content {
  flex-grow: 1;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.9rem;
  font-weight: 500;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Blue theme */
.stat-card-blue {
  border-left-color: #6CB4EE;
}

.stat-card-blue .stat-icon {
  background-color: #E3F2FD;
  color: #1976D2;
}

.stat-card-blue .stat-value {
  color: #1565C0;
}

/* Green theme */
.stat-card-green {
  border-left-color: #77DD77;
}

.stat-card-green .stat-icon {
  background-color: #E8F5E9;
  color: #388E3C;
}

.stat-card-green .stat-value {
  color: #2E7D32;
}

/* Purple theme */
.stat-card-purple {
  border-left-color: #B19CD9;
}

.stat-card-purple .stat-icon {
  background-color: #F3E5F5;
  color: #7B1FA2;
}

.stat-card-purple .stat-value {
  color: #6A1B9A;
}

/* Orange theme */
.stat-card-orange {
  border-left-color: #FFB347;
}

.stat-card-orange .stat-icon {
  background-color: #FFF3E0;
  color: #E65100;
}

.stat-card-orange .stat-value {
  color: #D84315;
}

/* Teal theme */
.stat-card-teal {
  border-left-color: #5FB7C0;
}

.stat-card-teal .stat-icon {
  background-color: #E0F2F1;
  color: #00695C;
}

.stat-card-teal .stat-value {
  color: #004D40;
}

/* Pink theme */
.stat-card-pink {
  border-left-color: #F2A8C7;
}

.stat-card-pink .stat-icon {
  background-color: #FCE4EC;
  color: #C2185B;
}

.stat-card-pink .stat-value {
  color: #880E4F;
}

/* Responsive design for statistics */
@media (max-width: 768px) {
  .statistics-container {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 15px;
  }

  .stat-card {
    padding: 15px;
  }

  .stat-icon {
    font-size: 2rem;
    width: 50px;
    height: 50px;
  }

  .stat-value {
    font-size: 1.5rem;
  }
}
</style>